module.exports = __webpack_public_path__ + "static/media/load360.d42bd390.gif";